import { render, staticRenderFns } from "./MsgCallback.vue?vue&type=template&id=ede93634&"
import script from "./MsgCallback.vue?vue&type=script&lang=ts&"
export * from "./MsgCallback.vue?vue&type=script&lang=ts&"
import style0 from "./MsgCallback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports